import { useSelector } from 'react-redux';
import { VT911 } from '@rsos/capstone/src/constants/capabilities';
import { selectUserPermissionsByApp } from '@rsos/sinatra';
import { RootState } from '../app';
import { VT911_PERMISSION } from '../constants/permissions';

const useIsVT911Enabled = () => {
  const user = useSelector((state: RootState) => state.sinatra.user);
  const currentPSAP = useSelector(
    (state: RootState) => state.psaps.currentPSAP,
  );

  const permissions =
    user.profile && selectUserPermissionsByApp(user, 'capstone');

  return Boolean(
    currentPSAP?.activeCapabilities?.[VT911] &&
      permissions?.includes(VT911_PERMISSION),
  );
};

export default useIsVT911Enabled;
